import React from 'react'
import * as styles from './Header.module.css'
import Logo from '../../images/logo.png'

export default function Header() {
    return (
        <div className={`${styles.header} ${styles.alignFull}`}>
            <div className={styles.headerContainer}>
                <img src={Logo} alt="CryptoMerchants" className={styles.image} />
                <div>
                    <h1>Accept cryptocurrency as payment in store or online.</h1>
                    <h2>CryptoMerchants is a platform that allows you to accept cryptocurrency as payment in store or online.</h2>
                </div>
            </div>
        </div>
    )
}
